
import {Component, Prop, Vue} from "vue-property-decorator";
import DataFieldCache from "../../../models/data.field.cache";
import dataFieldTypes from "@/dataFieldTypes";
import Hints from "@/components/study/datafields/base/Hints.vue";

@Component({
  name: 'FieldGroup',
  components: {
    Hints,
    ...dataFieldTypes,
  },
})
export default class FieldGroup extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  get isVisible() {
    return this.dataField?.isVisible ?? false;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get childFields() {
    return this.dataField?.childFields ?? [];
  }

  get isPlain() {
    return this.dataField.definition.ui?.style == "plain";
  }

  get isIndented() {
    return this.dataField.definition.ui?.childrenStyle == "indented";
  }

  get titleVisible() {
    return this.dataField.definition.ui?.titleVisible ?? true;
  }

}
